module.exports = __webpack_public_path__ + "static/media/slider-l3-360.f7197c83.webp";